/**
 * Gemeinde entity model class
 *
 * This file is part of ePlan
 * (c) Kaden und Partner AG
 */
import { BaseModel } from './BaseModel';
import { BaseCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import { createModel } from '@kp/js-model';

export class Stelle extends BaseModel {
    id = null;
    type = null;
    bfsnr = null;
    mr_mrs = null;
    title = null;
    first_name = null;
    last_name = null;
    address_line_1 = null;
    address_line_2 = null;
    street = null;
    house_number = null;
    dwelling_number = null;
    post_office_box = null;
    post_office_box_text = null;
    swiss_zip_code = null;
    swiss_zip_code_add_on = null;
    swiss_zip_code_id = null;
    foreign_zip_code = null;
    locality = null;
    town: string | null = null;
    country_id = null;
    organisation_name: string | null = null;
    organisation_name_add_on_1 = null;
    organisation_name_add_on_2 = null;
    uid = null;
    iam_id = null;
    active = null;
    email = null;
    phone = null;
    parent_stelle_id = null;
    eplan_email_address = null;

    //view fields
    uid_iam = null;


    mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'Stelle';
    }

    get swiss_zip_code_string() {
        return this.swiss_zip_code ? '' + this.swiss_zip_code : '';
    }
}

export async function createNewStelle(): Promise<Stelle> {
    const stelle = createModel(Stelle, {active: false});

    await stelle.save();
    return stelle;
}

export class StelleCollection extends BaseCollection<Stelle> {
    protected modelCls = Stelle;

    public getModelClassName(): string {
        return 'Stelle';
    }
}
